<template>
  <Icon
    name="tabs"
    :width="88"
    :height="76"
    :scale="4"
  >
    <path d="M32.9 32.7H5.6C2.5 32.7 0 30.2 0 27.1V5.6C0 2.5 2.5 0 5.6 0H32.9C36 0 38.5 2.5 38.5 5.6V27.1C38.5 30.2 36 32.7 32.9 32.7ZM8 24.7H30.5V8H8V24.7ZM82.4 32.7H55.1C52 32.7 49.5 30.2 49.5 27.1V5.6C49.5 2.5 52 0 55.1 0H82.4C85.5 0 88 2.5 88 5.6V27.1C88 30.2 85.5 32.7 82.4 32.7ZM57.5 24.7H80V8H57.5V24.7ZM32.9 76H5.6C2.5 76 0 73.5 0 70.4V48.9C0 45.8 2.5 43.3 5.6 43.3H32.9C36 43.3 38.5 45.8 38.5 48.9V70.4C38.5 73.5 36 76 32.9 76ZM8 68H30.5V51.3H8V68ZM82.4 76H55.1C52 76 49.5 73.5 49.5 70.4V48.9C49.5 45.8 52 43.3 55.1 43.3H82.4C85.5 43.3 88 45.8 88 48.9V70.4C88 73.5 85.5 76 82.4 76ZM57.5 68H80V51.3H57.5V68Z"
          fill="#78BE20"
    />
  </Icon>
</template>

<script>
import Icon from "../Elements/Icon";

export default {
  name: 'Tabs',
  components: { Icon },
}
</script>
